module.exports = __webpack_public_path__ + "img/Considerate Career.e5828191.svg";